import Constants from "../tools/constants.tools";
import { privateApi } from "./api.interceptor";


class GymSpaService {
  
  getGymspa = ({queryKey}) => {
    const [_, role] = queryKey
    if(role === Constants.GYM)
      return privateApi.get('/gym_spa/gyms');
    return privateApi.get('/gym_spa/spas');
  }
  getUserGym = ({id, queryKey}) => {
    const [_, role] = queryKey
    if(role === Constants.GYM)
      return privateApi.get(`/gym_spa/gyms/${id}`);
    return privateApi.get(`/gym_spa/spas/${id}`);
  }
  create = (data) => privateApi.post("/gym_spa/", data);
  payment = (data) => privateApi.put(`/gym_spa/payement/${data.id}`, data).then((response) =>{
    console.log('pay', response)
  }).catch((error) => {
    console.log('pay', error)
  })
  rejeter = (id) => privateApi.put(`/gym_spa/rejet/${id}`);
  terminer = (id) => privateApi.put(`/gym_spa/termine/${id}`);
  delete = (id) => privateApi.delete(`/gym_spa/${id}`);

}

export default new GymSpaService();